import { Show } from "solid-js";
import { SectionData } from "../data/home_v3_route_data";
import { BrandGrid } from "./brand_grid";

export type SectionHeaderProps = {
  title: string;
  onBrandClick: (brandKey: string) => void;
  colorIndex: number;
  sectionData: SectionData;
};

// 5 colors to rotate through for sections
const SECTION_COLORS = [
  "#351A75", // Light pink
  "#68123D", // Light blue
  "#0B4627", // Light orange
  // "#F0E5FF", // Light purple
  // "#E5FFF0", // Light green
];

export function SectionHeader(props: SectionHeaderProps) {
  const backgroundColor = () =>
    SECTION_COLORS[props.colorIndex % SECTION_COLORS.length];

  return (
    <div
      class="flex w-full flex-col items-center gap-5 pb-6 pt-7"
      style={{ "background-color": backgroundColor() }}
    >
      <div class="flex w-full max-w-[1024px] items-center px-3">
        <h2 class="whitespace-nowrap text-caption-semi-bold uppercase text-[#FFFFFF]">
          {props.title}
        </h2>
      </div>
      <Show when={props.sectionData.brandList}>
        <BrandGrid
          brands={props.sectionData.brandList!}
          onBrandClick={props.onBrandClick}
          forceDarkTheme={true}
        />
      </Show>
    </div>
  );
}

export type PopularBrandsSectionHeaderProps = {
  colorIndex: number;
};

export function PopularBrandsSectionHeader(
  _props: PopularBrandsSectionHeaderProps
) {
  return (
    <div class="flex w-full flex-col items-center px-3 sm:px-0 ">
      <div class="flex w-full max-w-[1024px] items-center gap-3">
        <div class="h-[1px] flex-1 bg-stroke-1" />
        <h2 class="whitespace-nowrap text-caption-semi-bold uppercase text-text-normal-secondary">
          Popular brands
        </h2>
        <div class="h-[1px] flex-1 bg-stroke-1" />
      </div>
    </div>
  );
}
